import React, {useEffect, useRef, useState} from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import CustomFormInput from "../_UI/customFormInput";
import {useDispatch, useSelector} from "react-redux";
import {sendIdoForm} from "../../store/main/action";

import checkActive from '../../theme/assets/svg/lp_check_active.svg';
import CustomFormDatePicker from "../_UI/customFormDatePicker";
import {toast} from "react-toastify";

const ApplyForm = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const shownRef = useRef(false);

    const idoFormStatusStarted = useSelector(store => store.main.idoFormStatusStarted);
    const idoFormStatus = useSelector(store => store.main.idoFormStatus);
    const idoFormStatusErr = useSelector(store => store.main.idoFormStatusErr);

    const [dropInvest1, setDropInvest1] = useState(false);
    const [dropInvest2, setDropInvest2] = useState(false);
    const [dropInvest3, setDropInvest3] = useState(false);
    const [dropInvest4, setDropInvest4] = useState(false);

    const [dropBottom1, setDropBottom1] = useState(false);
    const [dropBottom2, setDropBottom2] = useState(false);
    const [dropBottom3, setDropBottom3] = useState(false);

    const [project_name, set_project_name] = useState('');
    const [contact_name, set_contact_name] = useState('');
    const [contact_telegram, set_contact_telegram] = useState('');
    const [email, set_email] = useState('');
    const [referred_by, set_referred_by] = useState('');

    const [site_url, set_site_url] = useState('');
    const [twitter_url, set_twitter_url] = useState('');
    const [pitchdeck_url, set_pitchdeck_url] = useState('');
    const [tokenomics_url, set_tokenomics_url] = useState('');
    const [other_url, set_other_url] = useState('');

    const [project_founded_at, set_project_founded_at] = useState('');
    const [project_description, set_project_description] = useState('');
    const [ecosystem, set_ecosystem] = useState('');
    const [team_description, set_team_description] = useState('');
    const [team_members, set_team_members] = useState('');
    const [current_community_description, set_current_community_description] = useState('');
    const [users_size_description, set_users_size_description] = useState('');

    const [round1_stage, set_round1_stage] = useState('');
    const [round1_amount_raised, set_round1_amount_raised] = useState('');
    const [round1_post_money_valuation, set_round1_post_money_valuation] = useState('');
    const [round2_stage, set_round2_stage] = useState('');
    const [round2_amount_raised, set_round2_amount_raised] = useState('');
    const [round2_post_money_valuation, set_round2_post_money_valuation] = useState('');
    const [round3_stage, set_round3_stage] = useState('');
    const [round3_amount_raised, set_round3_amount_raised] = useState('');
    const [round3_post_money_valuation, set_round3_post_money_valuation] = useState('');
    const [round4_stage, set_round4_stage] = useState('');
    const [round4_amount_raised, set_round4_amount_raised] = useState('');
    const [round4_post_money_valuation, set_round4_post_money_valuation] = useState('');
    const [previous_investment_rounds_description, set_previous_investment_rounds_description] = useState('');
    const [most_valuable_investors_and_ticket_sizes_description, set_most_valuable_investors_and_ticket_sizes_description] = useState('');

    const [total_amount_raised_from_public_sales, set_total_amount_raised_from_public_sales] = useState('');
    const [preferred_amount_raised, set_preferred_amount_raised] = useState('');
    const [flexible_with_amount, set_flexible_with_amount] = useState(null);
    const [planned_dfv_tokens_at_launch, set_planned_dfv_tokens_at_launch] = useState('');
    const [other_information, set_other_information] = useState('');
    const [conduct_sale_at, set_conduct_sale_at] = useState('');

    const [exchanges_engaged, set_exchanges_engaged] = useState('');
    const [exchanges_finalised, set_exchanges_finalised] = useState('');
    const [centralised_exchanges_status_description, set_centralised_exchanges_status_description] = useState('');
    const [market_makers_engaged, set_market_makers_engaged] = useState('');
    const [market_makers_finalised, set_market_makers_finalised] = useState('');
    const [market_makers_status_description, set_market_makers_status_description] = useState('');
    const [market_agencies_partners, set_market_agencies_partners] = useState('');
    const [marketing_effort_status_description, set_marketing_effort_status_description] = useState('');

    const sendFormHandler = () => {
        dispatch(sendIdoForm({
            project_name,
            contact_name,
            contact_telegram,
            email,
            referred_by,
            site_url,
            twitter_url,
            pitchdeck_url,
            tokenomics_url,
            other_url,
            project_founded_at,
            project_description,
            ecosystem,
            team_description,
            team_members,
            current_community_description,
            users_size_description,
            round1_stage,
            round1_amount_raised,
            round1_post_money_valuation,
            round2_stage,
            round2_amount_raised,
            round2_post_money_valuation,
            round3_stage,
            round3_amount_raised,
            round3_post_money_valuation,
            round4_stage,
            round4_amount_raised,
            round4_post_money_valuation,
            previous_investment_rounds_description,
            most_valuable_investors_and_ticket_sizes_description,
            total_amount_raised_from_public_sales,
            preferred_amount_raised,
            flexible_with_amount,
            planned_dfv_tokens_at_launch,
            other_information,
            conduct_sale_at,
            exchanges_engaged,
            exchanges_finalised,
            centralised_exchanges_status_description,
            market_makers_engaged,
            market_makers_finalised,
            market_makers_status_description,
            market_agencies_partners,
            marketing_effort_status_description,
        }));
    }

    const resetForm = () => {
        // --- dropdowns ---
        setDropInvest1(false);
        setDropInvest2(false);
        setDropInvest3(false);
        setDropInvest4(false);
        setDropBottom1(false);
        setDropBottom2(false);
        setDropBottom3(false);

        // --- top fields ---
        set_project_name('');
        set_contact_name('');
        set_contact_telegram('');
        set_email('');
        set_referred_by('');

        // --- urls ---
        set_site_url('');
        set_twitter_url('');
        set_pitchdeck_url('');
        set_tokenomics_url('');
        set_other_url('');

        // --- project details ---
        set_project_founded_at('');
        set_project_description('');
        set_ecosystem('');
        set_team_description('');
        set_team_members('');
        set_current_community_description('');
        set_users_size_description('');

        // --- rounds ---
        set_round1_stage('');
        set_round1_amount_raised('');
        set_round1_post_money_valuation('');
        set_round2_stage('');
        set_round2_amount_raised('');
        set_round2_post_money_valuation('');
        set_round3_stage('');
        set_round3_amount_raised('');
        set_round3_post_money_valuation('');
        set_round4_stage('');
        set_round4_amount_raised('');
        set_round4_post_money_valuation('');
        set_previous_investment_rounds_description('');
        set_most_valuable_investors_and_ticket_sizes_description('');

        // --- sale ---
        set_total_amount_raised_from_public_sales('');
        set_preferred_amount_raised('');
        set_flexible_with_amount(null);
        set_planned_dfv_tokens_at_launch('');
        set_other_information('');
        set_conduct_sale_at('');

        // --- exchanges / marketing ---
        set_exchanges_engaged('');
        set_exchanges_finalised('');
        set_centralised_exchanges_status_description('');
        set_market_makers_engaged('');
        set_market_makers_finalised('');
        set_market_makers_status_description('');
        set_market_agencies_partners('');
        set_marketing_effort_status_description('');
    };

    useEffect(() => {
        if (idoFormStatus && !shownRef.current) {
            shownRef.current = true;

            toast(t('Ваши данные успешно отправлены! Ожидайте когда наш представитель свяжеться с вами!'));
            resetForm();
        }

        if (!idoFormStatus) {
            shownRef.current = false; // если статус сбрасывается — разрешаем заново
        }
    }, [t, idoFormStatus]);

    return (
        <section className={Styles.container}>

            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}><span>{t('Основная')}</span> {t('информация')}</div>
                        <div className={`${Styles.posWrap}`}>
                            <CustomFormInput
                                title={`${t('Название проекта')} *`}
                                type="input"
                                placeholder="example"
                                name="project_name"
                                value={project_name}
                                onChangeAction={set_project_name}
                                err={idoFormStatusErr.project_name ? idoFormStatusErr.project_name : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Контактное лицо')} *`}
                                type="input"
                                placeholder="example"
                                name="contact_name"
                                value={contact_name}
                                onChangeAction={set_contact_name}
                                err={idoFormStatusErr.contact_name ? idoFormStatusErr.contact_name : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Telegram-ник контактного лица')} *`}
                                type="input"
                                placeholder="@example"
                                name="contact_telegram"
                                value={contact_telegram}
                                onChangeAction={set_contact_telegram}
                                err={idoFormStatusErr.contact_telegram ? idoFormStatusErr.contact_telegram : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Почта')} *`}
                                type="input"
                                placeholder="@example.com"
                                name="email"
                                value={email}
                                onChangeAction={set_email}
                                err={idoFormStatusErr.email ? idoFormStatusErr.email : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Рекомендовал(а)')}`}
                                type="input"
                                placeholder="example"
                                name="referred_by"
                                value={referred_by}
                                onChangeAction={set_referred_by}
                                err={idoFormStatusErr.referred_by ? idoFormStatusErr.referred_by : null}
                                formErr={idoFormStatusErr}
                            />
                        </div>
                        <div className={Styles.absLine}/>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}><span>{t('Ссылки')}</span></div>
                        <div className={`${Styles.posWrap}`}>
                            <CustomFormInput
                                title={`${t('Сайт')} *`}
                                type="input"
                                placeholder="https://example.com"
                                name="site_url"
                                value={site_url}
                                onChangeAction={set_site_url}
                                err={idoFormStatusErr.site_url ? idoFormStatusErr.site_url : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Twitter проекта')} *`}
                                type="input"
                                placeholder="https://twitter.com"
                                name="twitter_url"
                                value={twitter_url}
                                onChangeAction={set_twitter_url}
                                err={idoFormStatusErr.twitter_url ? idoFormStatusErr.twitter_url : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Питчдек')} *`}
                                type="input"
                                placeholder="https://drive.google.com"
                                name="pitchdeck_url"
                                value={pitchdeck_url}
                                onChangeAction={set_pitchdeck_url}
                                err={idoFormStatusErr.pitchdeck_url ? idoFormStatusErr.pitchdeck_url : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('График токена (токеномика)')} *`}
                                type="input"
                                placeholder="example"
                                name="tokenomics_url"
                                value={tokenomics_url}
                                onChangeAction={set_tokenomics_url}
                                err={idoFormStatusErr.tokenomics_url ? idoFormStatusErr.tokenomics_url : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Другие ссылки')}`}
                                type="input"
                                placeholder="https://..."
                                name="other_url"
                                value={other_url}
                                onChangeAction={set_other_url}
                                err={idoFormStatusErr.other_url ? idoFormStatusErr.other_url : null}
                                formErr={idoFormStatusErr}
                            />
                        </div>
                        <div className={Styles.absLine}/>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}><span>{t('Детали')}</span> {t('проекта')}</div>
                        <div className={`${Styles.posWrap}`}>
                            <CustomFormDatePicker
                                title={`${t("Когда был основан ваш проект")} *`}
                                name="project_founded_at"
                                value={project_founded_at}                 // "YYYY-MM-DD"
                                onChangeAction={set_project_founded_at}    // setState/dispatch
                                err={idoFormStatusErr.project_founded_at ?? null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Описание проекта')} *`}
                                type="textarea"
                                placeholder={t('Опишите ваш проект')}
                                name="project_description"
                                value={project_description}
                                onChangeAction={set_project_description}
                                err={idoFormStatusErr.project_description ? idoFormStatusErr.project_description : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Экосистема')} *`}
                                type="textarea"
                                placeholder={t('Опишите вашу экосистему')}
                                name="ecosystem"
                                value={ecosystem}
                                onChangeAction={set_ecosystem}
                                err={idoFormStatusErr.ecosystem ? idoFormStatusErr.ecosystem : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Описание команды')} *`}
                                type="textarea"
                                placeholder={t('Опишите вашу команду')}
                                name="team_description"
                                value={team_description}
                                onChangeAction={set_team_description}
                                err={idoFormStatusErr.team_description ? idoFormStatusErr.team_description : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Количество участников команды')} *`}
                                type="input"
                                placeholder="0-5 / 5-15 ..."
                                name="team_members"
                                value={team_members}
                                onChangeAction={set_team_members}
                                err={idoFormStatusErr.team_members ? idoFormStatusErr.team_members : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Опишите текущее сообщество')} *`}
                                type="textarea"
                                placeholder={t('Опишите ваше сообщество')}
                                name="current_community_description"
                                value={current_community_description}
                                onChangeAction={set_current_community_description}
                                err={idoFormStatusErr.current_community_description ? idoFormStatusErr.current_community_description : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Количество текущих пользователей')} *`}
                                type="textarea"
                                placeholder={t('Укажите подробности о текущем сообществе')}
                                name="users_size_description"
                                value={users_size_description}
                                onChangeAction={set_users_size_description}
                                err={idoFormStatusErr.users_size_description ? idoFormStatusErr.users_size_description : null}
                                formErr={idoFormStatusErr}
                            />
                        </div>
                        <div className={Styles.absLine}/>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}><span>{t('Капитал')}</span></div>
                        <div className={`${Styles.posWrap}`}>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropInvest1 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropInvest1(!dropInvest1)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNote}`}>
                                        {t('Инвестиционный раунд')} 1
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropInvest1 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`1 - ${t('Стадия раунда')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round1_stage"
                                        value={round1_stage}
                                        onChangeAction={set_round1_stage}
                                        err={idoFormStatusErr.round1_stage ? idoFormStatusErr.round1_stage : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`1 - ${t('Какую сумму удалось привлечь?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round1_amount_raised"
                                        value={round1_amount_raised}
                                        onChangeAction={set_round1_amount_raised}
                                        err={idoFormStatusErr.round1_amount_raised ? idoFormStatusErr.round1_amount_raised : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`1 - ${t('Какой была оценка компании после раунда (post-money)?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round1_post_money_valuation"
                                        value={round1_post_money_valuation}
                                        onChangeAction={set_round1_post_money_valuation}
                                        err={idoFormStatusErr.round1_post_money_valuation ? idoFormStatusErr.round1_post_money_valuation : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropInvest2 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropInvest2(!dropInvest2)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNote}`}>
                                        {t('Инвестиционный раунд')} 2
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropInvest2 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`2 - ${t('Стадия раунда')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round2_stage"
                                        value={round2_stage}
                                        onChangeAction={set_round2_stage}
                                        err={idoFormStatusErr.round2_stage ? idoFormStatusErr.round2_stage : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`2 - ${t('Какую сумму удалось привлечь?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round2_amount_raised"
                                        value={round2_amount_raised}
                                        onChangeAction={set_round2_amount_raised}
                                        err={idoFormStatusErr.round2_amount_raised ? idoFormStatusErr.round2_amount_raised : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`2 - ${t('Какой была оценка компании после раунда (post-money)?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round2_post_money_valuation"
                                        value={round2_post_money_valuation}
                                        onChangeAction={set_round2_post_money_valuation}
                                        err={idoFormStatusErr.round2_post_money_valuation ? idoFormStatusErr.round2_post_money_valuation : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropInvest3 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropInvest3(!dropInvest3)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNote}`}>
                                        {t('Инвестиционный раунд')} 3
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropInvest3 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`3 - ${t('Стадия раунда')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round3_stage"
                                        value={round3_stage}
                                        onChangeAction={set_round3_stage}
                                        err={idoFormStatusErr.round3_stage ? idoFormStatusErr.round3_stage : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`3 - ${t('Какую сумму удалось привлечь?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round3_amount_raised"
                                        value={round3_amount_raised}
                                        onChangeAction={set_round3_amount_raised}
                                        err={idoFormStatusErr.round3_amount_raised ? idoFormStatusErr.round3_amount_raised : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`3 - ${t('Какой была оценка компании после раунда (post-money)?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round3_post_money_valuation"
                                        value={round3_post_money_valuation}
                                        onChangeAction={set_round3_post_money_valuation}
                                        err={idoFormStatusErr.round3_post_money_valuation ? idoFormStatusErr.round3_post_money_valuation : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropInvest4 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropInvest4(!dropInvest4)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNote}`}>
                                        {t('Инвестиционный раунд')} 4
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropInvest4 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`4 - ${t('Стадия раунда')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round4_stage"
                                        value={round4_stage}
                                        onChangeAction={set_round4_stage}
                                        err={idoFormStatusErr.round4_stage ? idoFormStatusErr.round4_stage : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`4 - ${t('Какую сумму удалось привлечь?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round4_amount_raised"
                                        value={round4_amount_raised}
                                        onChangeAction={set_round4_amount_raised}
                                        err={idoFormStatusErr.round4_amount_raised ? idoFormStatusErr.round4_amount_raised : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`4 - ${t('Какой была оценка компании после раунда (post-money)?')} *`}
                                        type="input"
                                        placeholder="Seed"
                                        name="round4_post_money_valuation"
                                        value={round4_post_money_valuation}
                                        onChangeAction={set_round4_post_money_valuation}
                                        err={idoFormStatusErr.round4_post_money_valuation ? idoFormStatusErr.round4_post_money_valuation : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                            <CustomFormInput
                                title={`${t('Укажите любую информацию о предыдущих инвестиционных раундах')}`}
                                type="textarea"
                                placeholder={t('Укажите информацию по соглашению')}
                                name="previous_investment_rounds_description"
                                value={previous_investment_rounds_description}
                                onChangeAction={set_previous_investment_rounds_description}
                                err={idoFormStatusErr.previous_investment_rounds_description ? idoFormStatusErr.previous_investment_rounds_description : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Кто три самых крупных/значимых инвестора и каков размер их инвестиций (тикетов)?')} *`}
                                type="textarea"
                                placeholder={t('ABC Capital в seed-раунде — $50k…')}
                                name="most_valuable_investors_and_ticket_sizes_description"
                                value={most_valuable_investors_and_ticket_sizes_description}
                                onChangeAction={set_most_valuable_investors_and_ticket_sizes_description}
                                err={idoFormStatusErr.most_valuable_investors_and_ticket_sizes_description ? idoFormStatusErr.most_valuable_investors_and_ticket_sizes_description : null}
                                formErr={idoFormStatusErr}
                            />
                        </div>
                        <div className={Styles.absLine}/>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}><span>{t('Публичная продажа')}</span> {t('токенов')}</div>
                        <div className={`${Styles.posWrap}`}>
                            <CustomFormInput
                                title={`${t('Какую общую сумму планируется привлечь через публичную продажу токенов?')} *`}
                                type="input"
                                placeholder="$1.000.000"
                                name="total_amount_raised_from_public_sales"
                                value={total_amount_raised_from_public_sales}
                                onChangeAction={set_total_amount_raised_from_public_sales}
                                err={idoFormStatusErr.total_amount_raised_from_public_sales ? idoFormStatusErr.total_amount_raised_from_public_sales : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Какую сумму вы бы предпочли привлечь через OMT Launchpad?')} *`}
                                type="input"
                                placeholder="$500.000"
                                name="preferred_amount_raised"
                                value={preferred_amount_raised}
                                onChangeAction={set_preferred_amount_raised}
                                err={idoFormStatusErr.preferred_amount_raised ? idoFormStatusErr.preferred_amount_raised : null}
                                formErr={idoFormStatusErr}
                            />
                            <div className={`${Styles.checkRow}`}>
                                <div className={`${Styles.checkRowTitle}`}>{t('Гибки ли вы по суммам?')} *</div>
                                <div className={`${Styles.checkRowWrap}`}>
                                    <div className={`${Styles.checkRowBox}`}>
                                        <div className={`${Styles.checkRowBoxItem}  ${flexible_with_amount === true ? Styles.checkRowBoxItemActive : null}`}
                                             onClick={()=>{
                                                 set_flexible_with_amount(true);
                                             }}
                                        >
                                            <img src={checkActive} alt="accept"/>
                                        </div>
                                        <div className={`${Styles.checkRowBoxText}`}>{t('Да')}</div>
                                    </div>
                                    <div className={`${Styles.checkRowBox}`}>
                                        <div className={`${Styles.checkRowBoxItem} ${flexible_with_amount === false ? Styles.checkRowBoxItemActive : null}`}
                                             onClick={()=>{
                                                 set_flexible_with_amount(false);
                                             }}
                                        >
                                            <img src={checkActive} alt="not accept"/>
                                        </div>
                                        <div className={`${Styles.checkRowBoxText}`}>{t('Нет')}</div>
                                    </div>
                                </div>
                            </div>
                            <CustomFormInput
                                title={`${t('Какой планируется FDV токена на запуске?')} *`}
                                type="input"
                                placeholder="$10.000.000"
                                name="planned_dfv_tokens_at_launch"
                                value={planned_dfv_tokens_at_launch}
                                onChangeAction={set_planned_dfv_tokens_at_launch}
                                err={idoFormStatusErr.planned_dfv_tokens_at_launch ? idoFormStatusErr.planned_dfv_tokens_at_launch : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormInput
                                title={`${t('Другая информация')} *`}
                                type="textarea"
                                placeholder={t('Другая информация')}
                                name="other_information"
                                value={other_information}
                                onChangeAction={set_other_information}
                                err={idoFormStatusErr.other_information ? idoFormStatusErr.other_information : null}
                                formErr={idoFormStatusErr}
                            />
                            <CustomFormDatePicker
                                title={`${t("Когда вы планируете провести продажу?")} *`}
                                placeholder={t("Estimate date (DD/MM/YYYY)")}
                                name="conduct_sale_at"
                                value={conduct_sale_at}                 // "YYYY-MM-DD"
                                onChangeAction={set_conduct_sale_at}
                                err={idoFormStatusErr.conduct_sale_at ?? null}
                                formErr={idoFormStatusErr}
                            />
                        </div>
                        <div className={Styles.absLine}/>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}><span>{t('Статус')}</span> {t('партнёрств')}</div>
                        <div className={`${Styles.posWrap}`}>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropBottom1 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropBottom1(!dropBottom1)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNoteS}`}>
                                        {t('Вели ли вы переговоры с централизованными биржами?')}
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropBottom1 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`${t('С какими биржами вы уже вели переговоры?')}`}
                                        type="input"
                                        placeholder="OKX, BINANCE, etc."
                                        name="exchanges_engaged"
                                        value={exchanges_engaged}
                                        onChangeAction={set_exchanges_engaged}
                                        err={idoFormStatusErr.exchanges_engaged ? idoFormStatusErr.exchanges_engaged : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`${t('С какими биржами уже достигнуты договорённости?')}`}
                                        type="input"
                                        placeholder="e.g Agreed with Binance but..."
                                        name="exchanges_finalised"
                                        value={exchanges_finalised}
                                        onChangeAction={set_exchanges_finalised}
                                        err={idoFormStatusErr.exchanges_finalised ? idoFormStatusErr.exchanges_finalised : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`${t('Какой статус по централизованным биржам?')}`}
                                        type="textarea"
                                        placeholder="Provide details on current status of CEX..."
                                        name="centralised_exchanges_status_description"
                                        value={centralised_exchanges_status_description}
                                        onChangeAction={set_centralised_exchanges_status_description}
                                        err={idoFormStatusErr.centralised_exchanges_status_description ? idoFormStatusErr.centralised_exchanges_status_description : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropBottom2 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropBottom2(!dropBottom2)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNoteS}`}>
                                        {t('Вели ли вы переговоры с маркетмейкерами?')}
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropBottom2 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`${t('С какими маркетмейкерами вы уже вели переговоры?')}`}
                                        type="input"
                                        placeholder="GSR, Wintermute, etc."
                                        name="market_makers_engaged"
                                        value={market_makers_engaged}
                                        onChangeAction={set_market_makers_engaged}
                                        err={idoFormStatusErr.market_makers_engaged ? idoFormStatusErr.market_makers_engaged : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`${t('С какими маркетмейкерами уже достигнуты договорённости?')}`}
                                        type="input"
                                        placeholder="ABC signed..."
                                        name="market_makers_finalised"
                                        value={market_makers_finalised}
                                        onChangeAction={set_market_makers_finalised}
                                        err={idoFormStatusErr.market_makers_finalised ? idoFormStatusErr.market_makers_finalised : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`${t('Какой статус по маркетмейкерам?')}`}
                                        type="textarea"
                                        placeholder="Provide details on current status of MMs..."
                                        name="market_makers_status_description"
                                        value={market_makers_status_description}
                                        onChangeAction={set_market_makers_status_description}
                                        err={idoFormStatusErr.market_makers_status_description ? idoFormStatusErr.market_makers_status_description : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                            <div className={`${Styles.investRow}`}>
                                <div className={`${Styles.investRowTitle} ${dropBottom3 ? Styles.investRowTitleActive : null}`} onClick={()=>{setDropBottom3(!dropBottom3)}}>
                                    <div className={`${Styles.investRowTitleImgWrap}`}>
                                        <img src={checkActive} alt={t('Инвестиционный раунд')}/>
                                    </div>
                                    <div className={`${Styles.investRowTitleNoteS}`}>
                                        {t('Вели ли вы переговоры с маркетинговыми агентствами?')}
                                    </div>
                                </div>
                                <div className={`${Styles.investRowContent} ${dropBottom3 ? Styles.investRowContentActive : null}`}>
                                    <CustomFormInput
                                        title={`${t('С какими маркетинговыми агентствами вы сотрудничаете?')}`}
                                        type="input"
                                        placeholder="Agancy names."
                                        name="market_agencies_partners"
                                        value={market_agencies_partners}
                                        onChangeAction={set_market_agencies_partners}
                                        err={idoFormStatusErr.market_agencies_partners ? idoFormStatusErr.market_agencies_partners : null}
                                        formErr={idoFormStatusErr}
                                    />
                                    <CustomFormInput
                                        title={`${t('Какой текущий статус маркетинговых активностей?')}`}
                                        type="textarea"
                                        placeholder="Provide details of what KOL networks the project is engaged with..."
                                        name="marketing_effort_status_description"
                                        value={marketing_effort_status_description}
                                        onChangeAction={set_marketing_effort_status_description}
                                        err={idoFormStatusErr.marketing_effort_status_description ? idoFormStatusErr.marketing_effort_status_description : null}
                                        formErr={idoFormStatusErr}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={Styles.absLine}/>
                    </div>
                </div>
                <div className={`${Styles.sendBtn} ${idoFormStatusStarted ? Styles.sendBtnDsb : null}`} onClick={()=>{sendFormHandler()}}>{t('Отправить данные')}</div>
            </div>
        </section>
    );
};

export default ApplyForm;




